class ProductFinderQuiz {
  constructor(questionSelector) {
    // Answers (local Answers inc. questions that are ignored for the result)
    this.answers = [];
    this.localAnswers = [];

    // Questions
    this.questions = document.querySelectorAll(questionSelector);
    this.allQuestions = document.querySelectorAll('.zq-question');

    // Results
    this.results = document.querySelectorAll('.zq-quiz-result-card');

    // Promo Section
    this.promoSection = document.querySelector('.zq-result-product-promo');
    this.promoCollection = document.querySelector('#promo-collection');

    // Klaviyo Sign Up Form Section
    this.signUpForm = document.querySelector('#zq-sign-up');

    //  Reset Button Section
    this.resetButton = document.querySelector('#resetQuiz');
    this.resetButton?.addEventListener('click', () => this.resetQuiz());

    // Local Storage Results Object
    this.key = localStorage.getItem('zq-product-finder-key');

    if (this.key) {
      const localStorageObj = JSON.parse(this.key);

      if (localStorageObj.timestamp) {
        const now = new Date();
        const timestamp = new Date(localStorageObj.timestamp);
        const diffTime = Math.abs(now - timestamp);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays > 14) {
          localStorage.removeItem('zq-product-finder-key');
          this.init();
          this.accordionsListener();
        } else {
          this.updateQuestions(localStorageObj.results);
          this.showResult(localStorageObj.results);
        }
      }
    } else {
      this.init();
      this.accordionsListener();
    }
  }

  updateQuestions(key) {
    key.split('_').forEach((answer, index) => {
      this.questions[index].querySelector(`input[value="${answer}"]`).checked = true;
    });
  }

  init() {
    this.answers = [];
    
    this.questions.forEach((questionEl, index) => {
      const inputs = questionEl.querySelectorAll('input[type="radio"], input[type="checkbox"]');
     
      inputs.forEach((input) => {
        input.addEventListener('change', () => {
            const value = input.value.toLowerCase();
            this.answers[index] = value;
    
            // First Question Started
            if (index === 0) {
                let eventdata = {};
                eventdata.name = "Quiz - Started";
                eventdata.timestamp = new Date().toISOString();
                Shopify.analytics.publish("Quiz - Started", eventdata);
            }
    
            // Question Answered
            let eventdata = {};
            eventdata.name = "Quiz - Question Answered";
            eventdata.timestamp = new Date().toISOString();
            eventdata.data = {};
            eventdata.data.question = questionEl.querySelector('label').textContent;
            eventdata.data.answer = value;
            
            // Actually publish the event
            Shopify.analytics.publish("Quiz - Question Answered", eventdata);
    
            if (this.allQuestionsAnswered()) {
                this.showSignUpForm(); 
            }
        });
    });
    });

    this.allQuestions.forEach((questionEl) => {
      this.localAnswers = [];
      const inputs = questionEl.querySelectorAll('input[type="radio"], input[type="checkbox"]');
     
      inputs.forEach((input, index) => {
        input.addEventListener('change', () => {
            const value = input.value.toLowerCase();
            this.localAnswers[index] = value;

            if (!this.allQuestionsAnswered()) {
                this.showNextQuestion(input);
              }
            }
        );
      });
    });

    window.addEventListener('resize', this.accordionsListener.bind(this));
    this.accordionsListener();
  }

  allQuestionsAnswered() {
    let count = 0;
    let total = this.allQuestions.length;

    this.allQuestions.forEach(question => {
      question.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(input => {
          if (input.checked) {  
            count++;
          }
      })
    });

    if (count === total) {
      return true;
    }
  }

  showNextQuestion(element) {
    const parentElement = element.closest('.zq-question');
    const nextQuestion = parentElement.nextElementSibling;
    
    if (nextQuestion && nextQuestion.classList.contains('zq-question')) {
     
      // Open Next Accordion
      nextQuestion.dataset.active = "true";
      nextQuestion.classList.remove('hidden');
      nextQuestion.setAttribute('aria-expanded', 'true');
      
      // Scroll to next question
      setTimeout(() => {
        nextQuestion.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 400);
      
    }
  }

  compareAnswers() {
    const resultKey = this.answers.join('_');

    const validKeys = new Set([
      "true_true",
      "true_false",
      "false_true",
      "false_false"
    ]);

    if (validKeys.has(resultKey)) {
      let resultsObj = {
        "results": resultKey,
        "localResults": this.localAnswers.join('_'),
        "timestamp": new Date().toISOString()
      }

      localStorage.setItem('zq-product-finder-key', JSON.stringify(resultsObj));
    }

    if (this.signUpForm.querySelector('form.klaviyo-form')) {
      window.addEventListener("klaviyoForms", (e) => { 
        if (e.detail.type == 'submit') {
          this.signUpForm.classList.add('hidden');
          this.customerEmail = e.detail.metaData.$email;
          this.showResult(validKeys.has(resultKey) ? resultKey : "false_true");
        }
      });
    } else {
      this.showResult(validKeys.has(resultKey) ? resultKey : "false_true");
    }
  }

  handleAccordionClick(event) {
    const question = event.currentTarget;
    const isExpanded = question.getAttribute('aria-expanded') === 'true';
    question.setAttribute('aria-expanded', !isExpanded);
    question.classList.toggle('hidden', isExpanded);
  }

  initAccordions(container) {
    container.querySelectorAll('.zq-question').forEach((question, i) => {
      const isFirstOrActive = question.getAttribute('aria-expanded') || i === 0;
      question.setAttribute('aria-expanded', isFirstOrActive);
      question.addEventListener('click', this.handleAccordionClick);
    });
  }

  removeAccordions(container) {
    container.querySelectorAll('.zq-question').forEach((question) => {
      question.removeAttribute('aria-expanded');
      question.removeEventListener('click', this.handleAccordionClick);
    });
  }

  accordionsListener() {
    if (window.innerWidth < 1001) {
        this.initAccordions(document.querySelector('.zq-product-finder'));
      } else {
        this.removeAccordions(document.querySelector('.zq-product-finder'));
      }
  }


  initQtySelectors(container) {
    container.querySelectorAll('.js-qty__wrapper').forEach((el) => {
      new theme.QtySelector(el, {
        namespace: '.product-finder',
      });
    });
  }

  initSwiper(container) { 
    if (container === this.promoCollection.querySelector('.swiper')) {
      const swiper = new window.swiper(container, {
        slidesPerView: 1.2,
        navigation: {
            nextEl: this.promoCollection.querySelector('.swiper-button-next'),
            prevEl: this.promoCollection.querySelector('.swiper-button-prev'),
        },
        spaceBetween: 10,
        zoom: true,

        breakpoints: {
          440: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          1400: {
            slidesPerView: 4,
          },
        }
    });
    } else {
      const swiper = new window.swiper(container, {
          navigation: {
              nextEl: container.querySelector('.swiper-button-next'),
              prevEl: container.querySelector('.swiper-button-prev'),
          },
          spaceBetween: 10,
          zoom: true,

          on: {
            beforeSlideChangeStart: () => {
              container.querySelector('.swiper-wrapper').classList.remove('vw-product-widgets-container');
            }
          }
      });
    }
  }

  disableQuiz() {
    this.allQuestions.forEach(question => {
      question.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(input => {
        input.disabled = true;
      });
    });

    this.resetButton.style.display = 'flex';
  }

  resetQuiz() {
    this.allQuestions.forEach((question, index) => {
      question.classList.remove('hidden');
      question.setAttribute('aria-expanded', 'false');

      question.dataset.active = index === 0 ? "true" : "false";

      question.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(input => {
        input.checked = false;
        input.disabled = false;
      });
    });

    this.results.forEach(result => {
      result.classList.add('hidden');
    })

    document.querySelector('#zq-results').classList.add('hidden');
    this.resetButton.style.display = 'none';

    this.promoSection?.classList.add('hidden');
    this.promoCollection?.classList.add('hidden');

    window.scrollTo({
      top: this.allQuestions[0].offsetTop - 100,
      behavior: 'smooth'
    });

    localStorage.removeItem('zq-product-finder-key');

    this.key = null;
    this.localAnswers = [];
    this.answers = [];
    this.init();
  }

  showResult(data) {
    const resultsContainer = document.querySelector('#zq-results');
    const resultCard = resultsContainer.querySelector(`#${data}`);
    const mainGallery = resultCard.querySelector('.main-product .zq-product-gallery');
    const altGallery = resultCard.querySelector('.alternative-product .zq-product-gallery');
    const galleries = [mainGallery, altGallery];

    resultsContainer.classList.remove('hidden');
    resultCard.classList.remove('hidden');
    this.promoSection?.classList.remove('hidden');
    this.promoCollection?.classList.remove('hidden');

    this.initQtySelectors(resultCard);

    if (this.promoSection) {
      this.initQtySelectors(this.promoSection);
    }

    if (mainGallery) {
      this.initSwiper(mainGallery);
    }

    if (altGallery) {
      this.initSwiper(altGallery);
    }

    if (this.promoCollection) {
      this.initSwiper(this.promoCollection.querySelector('.swiper'));
    }

    resultsContainer.scrollIntoView({ behavior: 'smooth', top: 100 });

    const resultsObj = JSON.parse(resultCard.querySelector("#results-obj").textContent);
    let results;

    if (resultsObj.results) {
      results = [{
        "Main": resultsObj.results.main_product,
        "Alternative": resultsObj.results.alt_product,
      }];
    }

    this.identifyKlaviyo(this.customerEmail, results);
    this.sendToKlaviyo(results);
    this.disableQuiz();
  }

  sendToKlaviyo(results) {
    klaviyo.track('Product Finder Quiz', results);

    let eventdata = {};
    eventdata.timestamp = new Date().toISOString();
    eventdata.name = "Quiz - Complete";
    eventdata.data = {};
    eventdata.data.results = results;
  
    Shopify.analytics.publish("Quiz - Complete", eventdata);
  }

  identifyKlaviyo(email, results){
    klaviyo.identify({
      'email': email,
      'Product Quiz Results': results
    })
  }

  showSignUpForm() {
    this.signUpForm.classList.remove('hidden');

    window.scrollTo({
      top: this.signUpForm.offsetTop - 100,
      behavior: 'smooth'
    });

    this.compareAnswers();
  }

  
}
